"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactAwesomeReveal = require("react-awesome-reveal");

var _reactHelmet = require("react-helmet");

var _const = require("../const");

var S = _interopRequireWildcard(require("./styled"));

var _excluded = ["children", "triggerOnce"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var map = function map(obj, fn) {
  return Object.fromEntries(Object.entries(obj).map(function (_ref, i) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    return [k, fn(v, k, i)];
  }));
};

var Components = {
  fade: _reactAwesomeReveal.Fade,
  zoom: _reactAwesomeReveal.Zoom,
  slide: _reactAwesomeReveal.Slide,
  bounce: _reactAwesomeReveal.Bounce,
  "default": function _default(_ref3) {
    var children = _ref3.children,
        triggerOnce = _ref3.triggerOnce,
        props = _objectWithoutProperties(_ref3, _excluded);

    return /*#__PURE__*/_react["default"].createElement("div", props, children);
  }
};

var getComponentForAnimation = function getComponentForAnimation(animation) {
  if (animation === 'none') {
    return {
      component: 'default',
      direction: ''
    };
  }

  var values = animation.split('-');
  return {
    component: values[0],
    direction: values[1] ? values[1] : null
  };
};

var BlockDecorator = function BlockDecorator(_ref4) {
  var _styles$TYPE_BACKGROU;

  var children = _ref4.children,
      isInsertMode = _ref4.isInsertMode,
      isLayoutMode = _ref4.isLayoutMode,
      isPreviewMode = _ref4.isPreviewMode,
      state = _ref4.state,
      name = _ref4.name;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      styles = _useState2[0],
      setStyles = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      highlight = _useState4[0],
      setHighlight = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      isLayoutPlugin = _useState6[0],
      setIsLayoutPlugin = _useState6[1];

  (0, _react.useEffect)(function () {
    var _state$STATE_KEY_BACK = state[_const.STATE_KEY_BACKGROUND],
        backgroundValues = _state$STATE_KEY_BACK === void 0 ? undefined : _state$STATE_KEY_BACK,
        _state$STATE_KEY_POSI = state[_const.STATE_KEY_POSITION],
        positionValues = _state$STATE_KEY_POSI === void 0 ? undefined : _state$STATE_KEY_POSI,
        _state$STATE_KEY_BORD = state[_const.STATE_KEY_BORDER],
        borderValues = _state$STATE_KEY_BORD === void 0 ? undefined : _state$STATE_KEY_BORD,
        _state$STATE_KEY_EFFE = state[_const.STATE_KEY_EFFECTS],
        effectValues = _state$STATE_KEY_EFFE === void 0 ? undefined : _state$STATE_KEY_EFFE,
        _state$STATE_KEY_ANCH = state[_const.STATE_KEY_ANCHOR],
        anchorValues = _state$STATE_KEY_ANCH === void 0 ? undefined : _state$STATE_KEY_ANCH;
    var styles = {};

    if (positionValues) {
      var padding = positionValues[_const.TYPE_PADDING],
          margin = positionValues[_const.TYPE_MARGIN],
          paddingMobile = positionValues[_const.TYPE_PADDING_MOBILE];
      styles[_const.TYPE_PADDING] = map(padding, function (v) {
        return (v || {}).value || 0;
      });
      styles[_const.TYPE_MARGIN] = map(margin, function (v) {
        return (v || {}).value || 0;
      });
      styles[_const.TYPE_PADDING_MOBILE] = paddingMobile;
    }

    if (backgroundValues) {
      styles[_const.TYPE_BACKGROUND_COLOR] = backgroundValues[_const.TYPE_BACKGROUND_COLOR];
      styles[_const.TYPE_BACKGROUND_COLOR_OPACITY] = backgroundValues[_const.TYPE_BACKGROUND_COLOR_OPACITY];
      styles[_const.TYPE_BACKGROUND_IMAGE] = backgroundValues[_const.TYPE_BACKGROUND_IMAGE];
      styles[_const.TYPE_BACKGROUND_VIDEO] = backgroundValues[_const.TYPE_BACKGROUND_VIDEO];
      styles[_const.TYPE_BACKGROUND_POSITION] = backgroundValues[_const.TYPE_BACKGROUND_POSITION];
      styles[_const.TYPE_BACKGROUND_SIZE] = backgroundValues[_const.TYPE_BACKGROUND_SIZE];
      styles[_const.TYPE_BACKGROUND_REPEAT] = backgroundValues[_const.TYPE_BACKGROUND_REPEAT];
      styles[_const.TYPE_BACKGROUND_MODE] = backgroundValues[_const.TYPE_BACKGROUND_MODE];
      styles[_const.TYPE_BACKGROUND_LOADING_METHOD] = backgroundValues[_const.TYPE_BACKGROUND_LOADING_METHOD];
      styles[_const.TYPE_BACKGROUND_ALT_TEXT] = backgroundValues[_const.TYPE_BACKGROUND_ALT_TEXT];
    }

    if (borderValues) {
      styles[_const.TYPE_BORDER_X] = borderValues[_const.TYPE_BORDER_X];
      styles[_const.TYPE_BORDER_Y] = borderValues[_const.TYPE_BORDER_Y];
      styles[_const.TYPE_BORDER_COLOR] = borderValues[_const.TYPE_BORDER_COLOR];
      styles[_const.TYPE_BORDER_WIDTH] = borderValues[_const.TYPE_BORDER_WIDTH];
      styles[_const.TYPE_BORDER_STYLE] = borderValues[_const.TYPE_BORDER_STYLE];
    }

    if (effectValues) {
      styles[_const.TYPE_ANIMATION_STYLE] = effectValues[_const.TYPE_ANIMATION_STYLE];
      styles[_const.TYPE_ANIMATION_DELAY] = effectValues[_const.TYPE_ANIMATION_DELAY];
      styles[_const.TYPE_ANIMATION_DURATION] = effectValues[_const.TYPE_ANIMATION_DURATION];
      styles[_const.TYPE_ANIMATION_HOVER] = effectValues[_const.TYPE_ANIMATION_HOVER];
      styles[_const.TYPE_BOX_SHADOW] = effectValues[_const.TYPE_BOX_SHADOW];
    }

    if (anchorValues) {
      styles[_const.TYPE_ANCHOR_ID] = anchorValues[_const.TYPE_ANCHOR_ID];
    }

    setStyles(styles);
  }, [state]);
  (0, _react.useEffect)(function () {
    setHighlight(isInsertMode || isLayoutMode);
  }, [isInsertMode, isLayoutMode]);
  (0, _react.useEffect)(function () {
    setIsLayoutPlugin(name.startsWith('peracto/layout'));
  }, [name]);
  var animationStyle = styles && styles[_const.TYPE_ANIMATION_STYLE] ? styles[_const.TYPE_ANIMATION_STYLE] : 'none';
  var hoverStyle = styles && styles[_const.TYPE_ANIMATION_HOVER] ? styles[_const.TYPE_ANIMATION_HOVER] : 'none';
  var anim = getComponentForAnimation(animationStyle);
  var AnimationElement = isPreviewMode ? Components[anim.component] : Components['default'];
  var preloadImage = styles && styles[_const.TYPE_BACKGROUND_IMAGE] && styles[_const.TYPE_BACKGROUND_LOADING_METHOD] === 'preload';
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(AnimationElement, {
    fraction: 0.2,
    triggerOnce: true,
    delay: styles && styles[_const.TYPE_ANIMATION_DELAY],
    duration: styles && styles[_const.TYPE_ANIMATION_DURATION],
    direction: anim.direction
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "".concat(/[^/]*$/.exec(name)[0].toLowerCase().replaceAll(' ', '-'), "-component")
  }, /*#__PURE__*/_react["default"].createElement(S.ComponentWrapper, _extends({}, styles, {
    isPreviewMode: isPreviewMode,
    className: (0, _classnames["default"])('component-wrapper', _defineProperty({}, "".concat(hoverStyle), hoverStyle !== 'none' && isPreviewMode))
  }, (styles === null || styles === void 0 ? void 0 : styles[_const.TYPE_ANCHOR_ID]) && {
    id: styles[_const.TYPE_ANCHOR_ID]
  }, (styles === null || styles === void 0 ? void 0 : styles[_const.TYPE_BACKGROUND_IMAGE]) && ((_styles$TYPE_BACKGROU = styles[_const.TYPE_BACKGROUND_ALT_TEXT]) === null || _styles$TYPE_BACKGROU === void 0 ? void 0 : _styles$TYPE_BACKGROU.length) > 0 && {
    role: 'img',
    'aria-label': styles[_const.TYPE_BACKGROUND_ALT_TEXT]
  }), styles && styles[_const.TYPE_BACKGROUND_MODE] === _const.BACKGROUND_MODE_VIDEO_FLAG && /*#__PURE__*/_react["default"].createElement(S.ComponentVideo, {
    playsInline: true,
    autoPlay: true,
    loop: true,
    muted: true,
    src: styles[_const.TYPE_BACKGROUND_VIDEO],
    poster: styles[_const.TYPE_BACKGROUND_IMAGE]
  }), children, !isPreviewMode && /*#__PURE__*/_react["default"].createElement(S.ComponentBorder, {
    className: "component-border",
    highlight: highlight,
    isLayoutPlugin: isLayoutPlugin
  })))), preloadImage && /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react["default"].createElement("link", {
    rel: "preload",
    href: styles[_const.TYPE_BACKGROUND_IMAGE],
    as: "image"
  })));
};

var _default2 = BlockDecorator;
exports["default"] = _default2;